import React from "react";
import { EpgChannelCoverage } from "../../../../../models/epg/Models";
import Card from "../../../../../components/themed/Card";
import dayjs from "dayjs";


interface CoverageReportProps {
    channelCoverages: EpgChannelCoverage[]
}

const CoverageReport = ({ channelCoverages }: CoverageReportProps) => {

    const rowHeaders = [ "Name", "ID", "Latest End Datetime" ];

    return (
        <div className={`mb-10 mt-4`}>
            <p className={`font-bold text-2xl pb-4`}>Channel Listings</p>
            <Card>
                <div className={`p-10`}>
                    <div className={`grid grid-cols-3`}>
                        {
                            rowHeaders.map((header) => (
                                <p key={header} className={`font-bold py-2`}>{`${header}`}</p>
                            ))
                        }
                    </div>
                    {
                        channelCoverages.map((item, index) => {
                            const dateAndTime =  dayjs(item.latestEndDateTime).format("DD MMM YYYY [@] HH:mm");

                            return (
                                <div key = {index} className = {`grid grid-cols-3 py-3 border-b items-center`}>
                                    <div className = {`flex flex-row items-center gap-4`}>
                                        <img className={`w-14 h-14`} src={item.logo} alt={`${item.name} logo`} />
                                        <p>{item.name}</p>
                                    </div>
                                    <p>{item.id}</p>
                                    <p>{dateAndTime}</p>
                                </div>
                            );})
                    }
                </div>
            </Card>
        </div>
    );
};

export default CoverageReport;